<template>
	<div>
		<v-container>
			<div :class="['text-h6', 'pa-2', 'text-center']">
				{{ $t('titles.manuallyAdjustLoyaltyPoints') }}
			</div>
			<v-row>
				<v-col cols="12" class="pb-0">
					<v-row>
						<v-col cols="4">
							<div :class="['text-body-1', 'pt-5', 'pl-2']">
								{{ $t('labels.loyaltyTransactionType') }}
							</div>
						</v-col>
						<v-col cols="7">
							<v-radio-group v-model="loyaltyTransactionType" row mandatory>
								<v-radio :label="$t('fields.subtract')" value="oduzmi" class="pr-6"></v-radio>
								<v-radio :label="$t('fields.add')" value="dodaj"></v-radio>
							</v-radio-group>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" class="pt-0 pl-4 pl-2">
					<NumberField
						v-model="changeAmount"
						:errorBorder="!changeAmountValidation"
						:label="'* ' + $t('fields.loyaltyPoints')"
					></NumberField>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row class="text-center">
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import NumberField from '../../trinkets/NumberField';

export default {
	name: 'Cost',
	components: { NumberField },
	emits: ['close', 'reloadLoyaltyTransactions'],
	data() {
		return {
			loyaltyTransactionType: 'dodaj',
			changeAmount: null,
			changeAmountValidation: true,
		};
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.changeAmount == null) {
				success = false;
				this.changeAmountValidation = false;
			} else {
				if (this.changeAmount <= 0) {
					success = false;
					this.changeAmountValidation = false;
					errorMessages +=
						this.$t('alerts.negativeValueError').replace('%field%', this.$t('fields.loyaltyPoints')) +
						'<br />';
				} else {
					this.changeAmountValidation = true;
				}
			}
			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let payload = {
					transaction_type: this.loyaltyTransactionType,
					change_amount: this.changeAmount,
					candidate_id: this.$route.params.id,
					date: new Date().toISOString().slice(0, 10),
				};
				this.$APICall('post', 'loyalty-transactions', payload, (data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicAdd'));
						vm.$modalBus.$emit('reloadLoyaltyTransactions');
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
					this.$emit('close');
				});
			}
		},
	},
};
</script>
